export var PartIdentifierTag;
(function (PartIdentifierTag) {
    PartIdentifierTag["sectionGroup"] = "sectionGroup";
    PartIdentifierTag["section"] = "section";
    PartIdentifierTag["subsection"] = "subsection";
    PartIdentifierTag["fieldGroup"] = "fieldGroup";
    PartIdentifierTag["field"] = "field";
    PartIdentifierTag["selectOption"] = "selectOption";
})(PartIdentifierTag || (PartIdentifierTag = {}));
export function isSectionGroupPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'sectionGroup';
}
export function isSectionPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'section';
}
export function isSubsectionPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'subsection';
}
export function isFieldGroupPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'fieldGroup';
}
export function isFieldPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'field';
}
export function isSelectOptionPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'selectOption';
}
